function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 8a8 8 0 018-8h24a8 8 0 018 8v24a8 8 0 01-8 8H8a8 8 0 01-8-8V8z",
  fill: "#FCF3EE"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.791 30.25c-.253 0-.508-.054-.751-.166A1.768 1.768 0 0111 28.462V26.5h-.844A2.159 2.159 0 018 24.343V12.156C8 10.966 8.967 10 10.156 10h19.688c1.189 0 2.156.967 2.156 2.156v12.187a2.159 2.159 0 01-2.156 2.157H17.308l-3.32 3.282a1.773 1.773 0 01-1.196.469zM10.156 11.5a.657.657 0 00-.656.656v12.187c0 .362.294.657.656.657h1.594a.75.75 0 01.75.75v2.712c0 .159.104.23.166.26.06.027.175.058.291-.031l3.516-3.475A.75.75 0 0117 25h12.844a.657.657 0 00.656-.657V12.156a.657.657 0 00-.656-.656H10.156z",
  fill: "#DE722E"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.013 23.5a.748.748 0 01-.352-.088L20 21.997l-2.66 1.415a.75.75 0 01-1.092-.788l.51-3.006-2.16-2.128a.75.75 0 01.418-1.277l2.977-.437 1.333-2.73a.75.75 0 011.348 0l1.333 2.73 2.977.437a.75.75 0 01.417 1.277l-2.159 2.128.51 3.006a.75.75 0 01-.74.876zM20 20.398a.75.75 0 01.352.088l1.666.886-.32-1.889a.75.75 0 01.213-.66l1.365-1.344-1.879-.276a.75.75 0 01-.564-.413L20 15.084l-.832 1.706a.75.75 0 01-.565.413l-1.879.276 1.365 1.344a.75.75 0 01.213.66l-.32 1.889 1.666-.886a.75.75 0 01.352-.088z",
  fill: "#DE722E"
});

var SvgReportReviews = function SvgReportReviews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default SvgReportReviews;